import { useFormContext } from "react-hook-form";

import ButtonV2, { IndicativeButton } from "@/v2/Buttons";

export default function EditFormButtons() {
  const { reset, submitButtonRef, formState } = useFormContext();

  return (
    <>
      <ButtonV2
        color="red"
        onClick={() => reset(formState.defaultValues)}
        type="button"
        data-testid="expertFormCancelButton"
      >
        cancel
      </ButtonV2>
      <IndicativeButton
        ref={submitButtonRef}
        defaultColor="green"
        pendingColor="#0cf970"
        successColor="#2ecc71"
        failureColor="error"
        data-testid="expertFormSaveButton"
      >
        save
      </IndicativeButton>
    </>
  );
}
